/**
 * Calcule une taille responsive basée sur un écran de 1920px
 * @param {number} sizePx - taille en px sur un écran 1920px
 * @returns {string} - taille responsive (vw ou clamp)
 */
export default function normalizeFontSize(sizePx) {
    const baseWidth = 1920
    const vwValue = (sizePx / baseWidth) * 100

    if (sizePx > 32) {
        const minPx = sizePx - 10
        const maxPx = sizePx + 10
        // Use CSS clamp() for real responsive behavior
        return sizePx > 0 ? `clamp(${minPx}px, ${vwValue}vw, ${maxPx}px)` : 0
    } else if (sizePx > 24) {
        const minPx = sizePx - 7
        const maxPx = sizePx + 7
        // Use CSS clamp() for real responsive behavior
        return sizePx > 0 ? `clamp(${minPx}px, ${vwValue}vw, ${maxPx}px)` : 0
    } else if (sizePx > 16) {
        const minPx = sizePx - 4
        const maxPx = sizePx + 4
        // Use CSS clamp() for real responsive behavior
        return sizePx > 0 ? `clamp(${minPx}px, ${vwValue}vw, ${maxPx}px)` : 0
    } else {
        const minPx = sizePx - 2 < 11 ? 11 : sizePx - 2
        const maxPx = sizePx + 2
        // Use CSS clamp() for real responsive behavior
        return sizePx > 0 ? `clamp(${minPx}px, ${vwValue}vw, ${maxPx}px)` : 0
    }
}
